import {
  GET_BOOKING_REQUIRED_DATA,
  GET_BOOKING_REQUIRED_DATA_SUCCESS,
} from './types';

const initialState = {};

const requiredDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_BOOKING_REQUIRED_DATA:
      return {
        ...state,
        [action.payload.booking_ref]: false,
      };
    case GET_BOOKING_REQUIRED_DATA_SUCCESS:
      return {
        ...state,
        [action.payload.booking_ref]: Array.isArray(
          action.payload.required_data,
        )
          ? {}
          : action.payload.required_data,
      };
    default:
      return state;
  }
};

export default requiredDataReducer;
